import { createRouter, createWebHistory } from "vue-router";

import store from "./store/index.js";
import utils from "./utils/utils.js";
import { loadLocale } from "./configs/localization/localeLoader";

var routePermissionCheckType = { SINGULAR: 0, ALL: 1, ANY: 2 };

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: "/", redirect: "/home" },
        { path: "/home", component: () => import("./pages/home/HomePage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/login", component: () => import("./pages/account/LoginPage.vue"), meta: { requiresAuth: false, requiresLogin: false, requiresNewPassword: false }},
        { path: "/executive", component: () => import("./pages/executiveDashboard/ExecutivePage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/validate-otp", component: () => import("./pages/account/OtpPage.vue"), meta: { requiresAuth: false, requiresLogin: true, requiresNewPassword: false }},
        { path: "/faq/general", component: () => import("./pages/Faq/GeneralPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/operational-view/mt", component: () => import("./pages/operationalView/sections/MtView.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/operational-view/brand", component: () => import("./pages/operationalView/sections/BrandView.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/reset-password", component: () => import("./pages/account/ResetPasswordPage.vue"), meta: { requiresAuth: false, requiresLogin: false, requiresNewPassword: true }},
        { path: "/operational-view/analysis", component: () => import("./pages/operationalView/sections/AnalysisView.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/operational-view/operational", component: () => import("./pages/operationalView/sections/OperationalView.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/:notFound(.*)", name: "notFound", component: () => import("./pages/NotFoundPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/unauthorized", name: "unauthorized", component: () => import("./pages/NotAuthorizedPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false }},
        { path: "/feeds", component: () => import("./pages/feed/FeedPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "Monitoring", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/sniffdeck", component: () => import("./pages/sniffdeck/SniffdeckPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "SniffDeck", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/operations", component: () => import("./pages/operation/OperationPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "Engagement", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/reports", component: () => import("./pages/report/ReportPanelPage.vue"), name: "Reports", meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "MyReports", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/reply-approval", component: () => import("./pages/disasterCrisis/DisasterCrisisPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: ["AnswerApproved1", "AnswerApproved2"], routePermissionCheckType: routePermissionCheckType.ANY }},
        { path: "/alarms", name: "alarms", component: () => import("./pages/alarm/AlarmPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: ["AlarmAdmin", "AlarmIndividual"], routePermissionCheckType: routePermissionCheckType.ANY }},
        { path: "/faq/report",  name: "FaqReportPage",  component: () => import("./pages/Faq/ReportPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "OperationalView", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/faq/analysis",  name: "FaqAnalysisPage",  component: () => import("./pages/Faq/AnalysisPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "MyReports", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/faq/monitoring", name: "FaqMonitoringPage", component: () => import("./pages/Faq/MonitoringPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "Monitoring", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/faq/engagement", name: "FaqEngagementPage", component: () => import("./pages/Faq/EngagementPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "Engagement", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/faq/dashboard",  name: "FaqDashboardPage",  component: () => import("./pages/Faq/DashboardPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "OperationalView", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/report/:reportid", component: () => import("./pages/report/ReportPage.vue"), name: "ReportPage", props: true, meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "ActivityReport", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/faq/usermanuals",  name: "UserManualsPage",  component: () => import("./pages/Faq/UserManualsPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "IsExecutiveDashboard", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/report/upsert/:reportid?", component: () => import("./components/report/UpsertReport.vue"), name: "UpsertReportPage", props: true, meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "ActivityReport", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/faq/executivedashboard",  name: "FaqExecutiveDashboardPage",  component: () => import("./pages/Faq/ExecutiveDashboardPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "IsExecutiveDashboard", routePermissionCheckType: routePermissionCheckType.SINGULAR }},
        { path: "/faq/admin",  name: "FaqAdminPage",  component: () => import("./pages/Faq/AdminPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: ["BusinessAdministration", "ReportOperations" ,"PermissionOperations"], routePermissionCheckType: routePermissionCheckType.ANY }},
        { path: "/operational-reports", redirect: { name: "operationalReportInfo" }, component: () => import("./pages/operationalMonitoring/OperationalMonitoringPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "OperationalView", routePermissionCheckType: routePermissionCheckType.SINGULAR }, children: [
            {
                name: "operationalReportInfo",
                path: "/operational-reports/info",
                component: () => import("./components/operationalMonitoring/OperationalMonitoringInfo.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "userTransactionReport",
                path: "/operational-reports/user-transactions",
                component: () => import("./components/operationalMonitoring/UserTransactionReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "sentimentAnalysisReport",
                path: "/operational-reports/sentiment-analysis",
                component: () => import("./components/operationalMonitoring/SentimentAnalysisReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "operationalTransactionReport",
                path: "/operational-reports/operational-transactions",
                component: () => import("./components/operationalMonitoring/OperationalTransactionReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "moderationUserReport",
                path: "/operational-reports/user-moderation",
                component: () => import("./components/operationalMonitoring/ModerationUserReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "operationalSLReport",
                path: "/operational-reports/operational-service-level",
                component: () => import("./components/operationalMonitoring/OperationalSLReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "userTagReport",
                path: "/operational-reports/user-tag",
                component: () => import("./components/operationalMonitoring/UserTagReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "feedFinalizeTimeReport",
                path: "/operational-reports/feed-finalize-time",
                component: () => import("./components/operationalMonitoring/FeedFinalizeTimeReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "replyQualityReport",
                path: "/operational-reports/misaligned-responses",
                component: () => import("./components/operationalMonitoring/ReplyQualityReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            {
                name: "topFeederReport",
                path: "/operational-reports/top-feeder",
                component: () => import("./components/operationalMonitoring/TopFeederReport.vue"),
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },
            //Müşteri talebi doğrultusunda boş duran temsilci raporu sayfasına erişim kaldırıldı
            /*{
                name: "idleUserReport",
                path: "/operational-reports/idle-users",
                component: IdleUserReport,
                meta: { requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            }*/
        ]},
        { path: "/admin-panel", redirect: { name: "info" }, component: () => import("./pages/setting/AdminPanelPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "BusinessAdministration", routePermissionCheckType: routePermissionCheckType.SINGULAR }, children: [
            {
                name: "info",
                path: "/admin-panel/info",
                component: () => import("./components/setting/adminPanel/AdminPanelInfo.vue"),
                meta:{ requiresPermission: true, requiresPermissionName: "BusinessAdministration", routePermissionCheckType:routePermissionCheckType.SINGULAR }
            },
            {
                name: "keyword",
                path: "/admin-panel/keywords",
                component: () => import("./components/setting/adminPanel/AdminPanelKeyword.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'KeywordOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "tag",
                path: "/admin-panel/tags",
                component: () => import("./components/setting/adminPanel/AdminPanelTag.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'EditorKeywordOps',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "tagRule",
                path:"admin-panel/tag-rules",
                component: () => import("./components/setting/adminPanel/AdminPanelTagRule.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'EditorKeywordOps',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "banUser",
                path: "/admin-panel/ban-users",
                component: () => import("./components/setting/adminPanel/AdminPanelBanUser.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "mainCategory",
                path: "/admin-panel/main-categories",
                component: () => import("./components/setting/adminPanel/AdminPanelMainCategory.vue"),
                 meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "twitterAccounts",
                path: "/admin-panel/twitter-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelTwitter.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'TWITTER'}
            },
            {
                name: "youtubeAccounts",
                path: "/admin-panel/youtube-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelYoutube.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'YOUTUBE'}
            },
            {
                name: "tiktokAccounts",
                path: "/admin-panel/tiktok-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelTikTok.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'TIKTOK'}
            },
            {
                name: "linkedinAccounts",
                path: "/admin-panel/linkedin-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelLinkedIn.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'LINKEDIN'}
            },
            {
                name: "sikayetvarAccounts",
                path: "/admin-panel/sikayetvar-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelSikayetvar.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'SIKAYETVARCOM'}
            },
            {
                name: "facebookAccounts",
                path: "/admin-panel/facebook-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelFacebook.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'FACEBOOK'}
            },
            {
                name: "instagramAccounts",
                path: "/admin-panel/instagram-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelInstagram.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'INSTAGRAM'}
            },
            {
                name: "googlePlayAccounts",
                path: "/admin-panel/google-play-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelGooglePlay.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'GOOGLEPLAY'}
            },
            {
                name: "appStoreAccounts",
                path: "/admin-panel/app-store-accounts",
                component: () => import("./components/setting/adminPanel/AdminPanelAppStore.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ConnectAdmin',routePermissionCheckType:routePermissionCheckType.SINGULAR,sourceAvailableCheckName:'APPSTORE'}
            }
        ]},
        { path: "/permission", component: () => import("./pages/setting/PermissionPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "PermissionOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }, children: [
            {
                name: "permissionInfo",
                path: "/permission/info",
                component: () => import("./components/setting/permission/PermissionMenuInfo.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'PermissionOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },  
            {
                name: "users",
                path: "/permission/user",
                component: () => import("./components/setting/permission/PermissionUser.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'PermissionOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "groups",
                path: "/permission/group",
                component: () => import("./components/setting/permission/PermissionGroup.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'PermissionOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            }
        ]},
        { path: "/customer-management", component: () => import("./pages/setting/CustomerManagementPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }, children: [
            {
                name: "customerManagementInfo",
                path: "/customer-management/info",
                component: () => import("./components/setting/customerManagement/CustomerManagementMenuInfo.vue"),
                meta:{requiresPermission: true, requiresPermissionName: "ReportOperations", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },  
            {
                name: "engagementQueues",
                path: "/customer-management/engagement-queues",
                component: () => import("./components/setting/customerManagement/EngagementQueue.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'QueueOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementQueueRule",
                path: "/customer-management/engagement-queue-rule",
                component: () => import("./components/setting/customerManagement/EngagementQueueRule.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'QueueOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementTemplate",
                path: "/customer-management/engagement-template",
                component: () => import("./components/setting/customerManagement/EngagementTemplate.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ReportOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementCategory",
                path: "/customer-management/engagement-category",
                component: () => import("./components/setting/customerManagement/EngagementCategory.vue"),
                props: { categoryType: 1 },
                meta:{requiresPermission:true,requiresPermissionName:'CategoryResearchOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementStatus",
                path: "/customer-management/engagement-status",
                component: () => import("./components/setting/customerManagement/EngagementCategory.vue"),
                props: { categoryType: 2 },
                meta:{requiresPermission:true,requiresPermissionName:'CategoryResearchOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementOperationType",
                path: "/customer-management/engagement-operation-type",
                component: () => import("./components/setting/customerManagement/EngagementCategory.vue"),
                props: { categoryType: 3 },
                meta:{requiresPermission:true,requiresPermissionName:'CategoryResearchOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementFeederType",
                path: "/customer-management/engagement-feeder-type",
                component: () => import("./components/setting/customerManagement/EngagementFeederType.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'CategoryResearchOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementModerationReason",
                path: "/customer-management/engagement-moderation-reason",
                component: () => import("./components/setting/customerManagement/EngagementModerationReason.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ReportOperations'}
            },
            {
                name: "engagementWorkingHours",
                path: "/customer-management/engagement-working-hours",
                component: () => import("./components/setting/customerManagement/EngagementWorkingHours.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'ReportOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementAnswerGallery",
                path: "/customer-management/engagement-answer-gallery",
                component: () => import("./components/setting/customerManagement/EngagementAnswerGallery.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'QueueOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementSpellCheckDictionary",
                path: "/customer-management/engagement-spell-check-dictionary",
                component: () => import("./components/setting/customerManagement/EngagementSpellCheckDictionary.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'QueueOperations',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementUnmaskFeedTitle",
                path: "/customer-management/engagement-unmask-feed-title",
                component: () => import("./components/setting/customerManagement/EngagementUnmaskFeedTitle.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementFeedApprove",
                path: "/customer-management/engagement-feed-approve",
                component: () => import("./components/setting/customerManagement/EngagementFeedApprove.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementFeedSendPrivate",
                path: "/customer-management/engagement-feed-send-private",
                component: () => import("./components/setting/customerManagement/EngagementFeedSendPrivate.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementInformationTemplateTopic",
                path: "/customer-management/engagement-information-template-topic",
                component: () => import("./components/setting/customerManagement/EngagementInformationTemplateTopic.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementActiveEmoji",
                path: "/customer-management/engagement-active-emoji",
                component: () => import("./components/setting/customerManagement/EngagementActiveEmoji.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "engagementWorkspaceAi",
                path: "/customer-management/engagement-ai-audit",
                component: () => import("./components/setting/customerManagement/EngagementWorkspaceAi.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'BusinessAdministration',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            }
        ]},
        { path: "/super-user-operation", component: () => import("./pages/setting/SuperUserOperationPage.vue"), meta: { requiresAuth: true, requiresLogin: false, requiresNewPassword: false, requiresPermission: true, requiresPermissionName: "SuperUserCheck", routePermissionCheckType: routePermissionCheckType.SINGULAR }, children: [
            {
                name: "superUserOperationInfo",
                path: "/super-user-operation/info",
                component: () => import("./components/setting/superUserOperation/SuperUserOperationMenuInfo.vue"),
                meta:{ requiresPermission: true, requiresPermissionName: "SuperUserCheck", routePermissionCheckType: routePermissionCheckType.SINGULAR }
            },  
            {
                name: "superUserWorkspace",
                path: "/super-user-operation/workspaces",
                component: () => import("./components/setting/superUserOperation/SuperUserWorkspace.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'SuperUserCheck',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "superUserFaq",
                path: "/super-user-operation/faq",
                component: () => import("./components/setting/superUserOperation/SuperUserFaq.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'SuperUserCheck',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "superUserOperation",
                path: "/super-user-operation/super-users",
                component: () => import("./components/setting/superUserOperation/SuperUserOperation.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'SuperUserCheck',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "superUserGnipArchiveDisconnection",
                path: "/super-user-operation/gnip-archive-disconnection",
                component: () => import("./components/setting/superUserOperation/SuperUserGnipArchiveDisconnection.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'SuperUserCheck',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "superUserSearchTweet",
                path: "/super-user-operation/search-tweet",
                component: () => import("./components/setting/superUserOperation/SuperUserSearchTweet.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'SuperUserCheck',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "superUserManuelAccountCollect",
                path: "/super-user-operation/manuel-account-collect",
                component: () => import("./components/setting/superUserOperation/SuperUserManuelAccountCollect.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'SuperUserCheck',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            },
            {
                name: "superUserXStream",
                path: "/super-user-operation/x-stream",
                component: () => import("./components/setting/superUserOperation/SuperUserXStream.vue"),
                meta:{requiresPermission:true,requiresPermissionName:'SuperUserCheck',routePermissionCheckType:routePermissionCheckType.SINGULAR}
            }
        ]}
    ]
});

router.beforeEach(async function(to, _, next) {
    if (to.meta.requiresNewPassword == true && store.getters.isPasswordResetProcess == true) {
        next();

        return;
    } else if (to.meta.requiresNewPassword == true && store.getters.isPasswordResetProcess == false) {
        next("/home");

        return;
    }

    if ((to.meta.requiresAuth == true && store.getters.isAuthenticated == false) || (to.meta.requiresLogin == true && store.getters.isLoggedIn == false)) {
        if (to.path.includes("/report/")) {
            next({ path: "/login", query: { to: to.path }})
        } else {
            next("/login");
        }

        return;
    } else if (to.meta.requiresAuth == false && store.getters.isAuthenticated == true) {
        next("/home");

        return;
    } else {
        if (!utils.accountRelatedPaths.includes(to.path)) {
            await store.dispatch("checkClientContext");
            // Kullanıcının dili artık biliniyor; sayfa ilk çizilmeden önce o dilin dosyasını indir (tr ise bir şey yapmaz).
            await loadLocale(store.getters.languageId);
            store.dispatch("alarm/fetchAlarmNotifications");

            if (to.meta && to.meta.requiresPermission) {
                let hasPermission = false;
                let availabeSourceCheck = true;
                const permissionName = to.meta.requiresPermissionName;
                const checkType = to.meta.routePermissionCheckType ?? routePermissionCheckType.SINGULAR;
                
                if (checkType === routePermissionCheckType.SINGULAR) {
                    hasPermission = utils.utility.isGrantedPermission(permissionName);
                } else if (checkType === routePermissionCheckType.ALL) {
                    hasPermission = utils.utility.isAllGrantedPermission(Array.isArray(permissionName) ? permissionName : [permissionName]);
                } else if (checkType === routePermissionCheckType.ANY) {
                    hasPermission = utils.utility.isAnyGrantedPermission(Array.isArray(permissionName) ? permissionName : [permissionName]);
                }
                
                if (to.meta.sourceAvailableCheckName) availabeSourceCheck=utils.utility.isAvailableSource(to.meta.sourceAvailableCheckName);  

                if (!hasPermission || !availabeSourceCheck) {
                    next("/unauthorized");

                    return;
                }
            }

            void store.dispatch("checkExpiredAccounts").catch(() => undefined);
        }

        next();
    }
});

// Deploy sonrası açık kalan sekme, sunucuda artık bulunmayan eski hash'li bir chunk'ı isteyebilir.
// Hedef sayfayı bir kez tam yükleyerek güncel dosyaları alırız; 10 sn içinde tekrar olursa döngüye girmemek için yenilemeyiz.
const CHUNK_RELOAD_KEY = "chunkReloadAt";
const CHUNK_RELOAD_WINDOW_MS = 10000;

function isChunkLoadError(error) {
    if (!error) return false;

    const message = error.message || "";

    return error.name === "ChunkLoadError" || /Loading (CSS )?chunk [\w-]+ failed/i.test(message);
}

router.onError((error, to) => {
    if (!isChunkLoadError(error)) return;

    let lastReloadAt = 0;

    try {
        lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY)) || 0;
    } catch (e) {
        return;
    }

    if (Date.now() - lastReloadAt < CHUNK_RELOAD_WINDOW_MS) return;

    try {
        sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    } catch (e) {
        return;
    }

    window.location.assign(to && to.fullPath ? to.fullPath : window.location.href);
});

export default router;